





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class LinkTransaction extends Vue {
  @Prop({ required: true }) public id: string;
  @Prop({ required: false, default: "" }) public smartBridge: string;
  @Prop({ required: false, default: false }) public showSmartBridgeIcon: boolean;

  get hasDefaultSlot(): boolean {
    return !!this.$slots.default;
  }
}
